/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box, Title } from '@mantine/core';

// Styles
import classes from './Header.module.css';

// Components
import { Text } from '@components/atoms/Text';

// I18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Header = () => {
	/* ******************************** HOOKS ******************************* */
	const { t } = useTranslation();
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Box className={classes.containerEmpty} />
			<Box className={classes.containerForm}>
				<Box className={classes.row}>
					<Box className={classes.containerTitle}>
						<Title className={classes.titleForm}>
							{t('offsets.title')}
						</Title>
						<Text className={classes.subTitleForm}>
							/ {t('offsets.subTitle')}
						</Text>
					</Box>
				</Box>
			</Box>
			<Box className={classes.containerEmpty} />
		</Box>
	);
};
